import React from 'react'
import Header from '../Components/Header/header'
import PortfolioCarousel from '../Components/PortfoloCarousel/portfoliocarousel'
import Portfolio from '../Components/Portfolio/portfolio'

const Projects = () => {
  return (
    <div>
        <Header/>
      <PortfolioCarousel/>
      <Portfolio/>
    </div>
  )
}

export default Projects